export default {"src":"/_next/static/media/coderpad-atlas.4666d3c1.svg","height":64,"width":64};